import { Download, X } from "lucide-react";
import { useInstallPrompt } from "../../hooks/useInstallPrompt";

export function InstallBanner() {
  const { canInstall, install, dismiss } = useInstallPrompt();

  if (!canInstall) return null;

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 bg-[#eff3ff] border-b border-[#bac8ff] md:hidden">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#2447d9]">
        <span className="text-sm font-extrabold text-white">M</span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-[#1e3a8a] leading-tight">
          Add MGC Hub to Home Screen
        </p>
        <p className="text-[10px] text-[#4263eb] leading-tight">
          Quick access from your phone
        </p>
      </div>
      <button
        onClick={install}
        className="flex shrink-0 items-center gap-1.5 rounded-lg bg-[#2447d9] px-3 py-1.5 text-xs font-semibold text-white"
      >
        <Download className="h-3.5 w-3.5" />
        Install
      </button>
      <button
        onClick={dismiss}
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-[#64748b] hover:bg-[#dbe4ff] transition-colors"
        aria-label="Dismiss install prompt"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
